import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NavComponent} from './nav/nav.component';
import {AuthComponent} from './components/auth/auth.component';
import {FooterComponent} from './components/footer/footer.component';
import {HomeComponent} from 'projects//paid_ukr/src/app/routes/home/home.component';
import {EyeTrackingTestComponent} from 'projects//paid_ukr/src/app/routes/eye-tracking-test/eye-tracking-test.component';
import {QuestionnaireComponent} from 'projects//paid_ukr/src/app/routes/questionnaire/questionnaire.component';
import {ResultsComponent} from 'projects//paid_ukr/src/app/routes/results/results.component';
import {
    NgbAccordionModule, NgbActiveModal,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule, NgbProgressbarModule,
    NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';
import {AngularFireStorageModule} from '@angular/fire/compat/storage';
import {AngularFireDatabaseModule} from '@angular/fire/compat/database';
import {SigninComponent} from './components/auth/signin/signin.component';
import {SignupComponent} from './components/auth/signup/signup.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {EyeTrackerModule} from 'projects/eye-tracker/src/lib/eye-tracker.module';
import {CalibrationComponent} from './routes/calibration/calibration.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpLoaderFactory} from 'projects/free/src/app/app.module';
import {SharedModule} from 'projects/shared/src/lib/shared.module';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {NgxMaskModule} from 'ngx-mask';
import {environment} from '../environments/environment';
import {AngularFireModule} from '@angular/fire/compat';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {TermsAndConditionsComponent} from './routes/terms-and-conditions/terms-and-conditions.component';
import {ToastrModule} from 'ngx-toastr';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {NgxPayPalModule} from 'ngx-paypal';
import {UserSessionsComponent} from './routes/user-sessions/user-sessions.component';
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {ConfirmSignInComponent} from './components/auth/confirm-sign-in/confirm-sign-in.component';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {FilterByPipe} from './services/filter-by.pipe';
import {FeaturedBlogPostsComponent} from './components/featured-blog-posts/featured-blog-posts.component';
import {HomeHeroComponent} from './components/home-hero/home-hero.component';
import {AboutUsComponent} from './components/about-us/about-us.component';
import {AboutUsItemComponent} from './components/about-us/about-us-item/about-us-item.component';
import {AchivementComponent} from './components/achivement/achivement.component';
import {PublicationsComponent} from './components/publications/publications.component';
import {PublicationItemComponent} from './components/publications/publication-item/publication-item.component';
import {ForWhoomComponent} from './components/for-whoom/for-whoom.component';
import {ForWhoomItemComponent} from './components/for-whoom/for-whoom-item/for-whoom-item.component';
import {ReviewsItemComponent} from './components/reviews/reviews-item/reviews-item.component';
import {ReviewsPagerComponent} from './components/reviews/reviews-pager/reviews-pager.component';
import {PlansComponent} from './components/plans/plans.component';
import {PlansItemComponent} from './components/plans/plans-item/plans-item.component';
import {FaqComponent} from './components/faq/faq.component';
import {FaqItemComponent} from './components/faq/faq-item/faq-item.component';
import {ChooseTestComponent} from './components/choose-test/choose-test.component';
import {ChooseTestItemComponent} from './components/choose-test/choose-test-item/choose-test-item.component';
import {ResultsContentComponent} from './components/results-content/results-content.component';
import {ResultsWarningComponent} from './components/results-content/results-warning/results-warning.component';
import {
    ResultsTrackerCalibrationComponent
} from './components/results-content/results-tracker/results-tracker-calibration/results-tracker-calibration.component';
import {ResultsTrackerComponent} from './components/results-content/results-tracker/results-tracker.component';
import {
    TrackerArousalPerformanceComponent
} from './components/results-content/results-tracker/tracker-arousal-performance/tracker-arousal-performance.component';
import {
    TrackerVulnerabilityStressComponent
} from './components/results-content/results-tracker/tracker-vulnerability-stress/tracker-vulnerability-stress.component';
import {TrackerCalendarComponent} from './components/results-content/results-tracker/tracker-calendar/tracker-calendar.component';
import {RecommendationsComponent} from './components/results-content/recommendations/recommendations.component';
import {
    RecommendationsItemComponent
} from './components/results-content/recommendations/recommendations-item/recommendations-item.component';
import {SelectTestComponent} from './routes/select-test/select-test.component';
import {ResultsReminderComponent} from './components/results-content/results-tracker/results-reminder/results-reminder.component';
import {TestResultsComponent} from './components/results-content/test-results/test-results.component';
import {TestPieChartComponent} from './components/results-content/test-results/test-pie-chart/test-pie-chart.component';
import {TestLineChartComponent} from './components/results-content/test-results/test-line-chart/test-line-chart.component';
import {ResultShareLinksComponent} from './components/results-content/test-results/result-share-links/result-share-links.component';
import {PaymentComponent} from './components/payment/payment.component';
import {WhatIsAnimaModalComponent} from './components/what-is-anima-modal/what-is-anima-modal.component';
import {DetailsComponent} from './components/results-content/details/details.component';
import {IArrowComponent} from './components/i-arrow/i-arrow.component';
import {GetHelpComponent} from './components/get-help/get-help.component';
import {ErrorModalComponent} from './components/error-modal/error-modal.component';
import {AboutPageComponent} from './components/about-page/about-page.component';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {CalendarModalComponent} from './components/results-content/test-results/calendar-modal/calendar-modal.component';
import {UnsubscribeComponent} from './routes/unsubscribe/unsubscribe.component';
import {TraceService} from '@sentry/angular';
import {NgcCookieConsentConfig, NgcCookieConsentModule} from 'ngx-cookieconsent';
import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
import {AfterPaymentComponent} from './components/after-payment/after-payment.component';
import {IndexDynamicComponent} from './components/results-content/results-tracker/results-indexes/index-dynamic/index-dynamic.component';
import { TestComponent } from './components/test/test.component';
import { VideoStreamComponent } from './components/video-stream/video-stream.component';
import {ReviewsComponent} from './components/reviews/reviews.component';
import { ReportComponent } from './routes/report/report.component';
import {ProgressComponent} from './routes/progress/progress.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {DashboardCalendarComponent} from './components/dashboard/dashboard-calendar/dashboard-calendar.component';
import { PatientDashboardComponent } from './components/dashboard/patient-dashboard/patient-dashboard.component';
import { NewSessionModalComponent } from './components/dashboard/new-session-modal/new-session-modal.component';
import { NewClientSessionComponent } from './components/dashboard/new-client-session/new-client-session.component';
import { ForBusinessComponent } from './routes/for-business/for-business.component';
import {HomeHeroForBusinessComponent} from './components/for-buseness/home-hero-for-buseness/home-hero-business.component';
import {AboutUsBusinessComponent} from './components/for-buseness/about-us-business/about-us-business.component';
import {AboutUsBItemComponent} from './components/for-buseness/about-us-business/about-us-item/about-us-item.component';
import {LineProgressComponent} from './components/results-content/details/line-progress/line-progress.component';
import {ResultsIndexesComponent} from './components/results-content/results-tracker/results-indexes/results-indexes.component';
import {CountUpDirective} from './services/count-up.directive';
import { PricingComponent } from './routes/pricing/pricing.component';
import {HomeHeroAiLandingComponent} from './components/ai-landing/home-hero-ai-landing/home-hero-ai-landing.component';
import {AiLandingComponent} from './routes/ai-landing/ai-landing.component';
import { UserAnswersComponent } from './components/results-content/user-answers/user-answers.component';
import { PromoComponent } from './routes/promo/promo.component';
import {AboutUsAiComponent} from './components/about-us-ai/about-us-ai.component';
import {AboutUsAiItemComponent} from './components/about-us-ai/about-us-ai-item/about-us-ai-item.component';
import {SidebarComponent} from './components/chat-components/chat-components/sidebar/sidebar.component';
import {ChatResultsComponent} from './components/chat-components/chat-components/chat-results/chat-results.component';
import {NewChatComponent} from './components/chat-components/chat-components/new-chat/new-chat.component';
import { AngularFireAuth } from '@angular/fire/compat/auth';

const cookieConfig: NgcCookieConsentConfig = {
    cookie: {
        domain: environment.production ? 'ua.anima.help' : 'localhost'
    },
    position: 'bottom',
    theme: 'block',
    palette: {
        popup: {
            background: '#10082f',
            text: '#ffffff',
            link: '#ffffff'
        },
        button: {
            background: '#ffffff',
            text: '#10082f',
            border: 'transparent'
        }
    },
    type: 'info',
    content: {
        message: 'Ваша конфіденційність важлива для нас. Наш веб-сайт за замовчуванням використовує лише файли cookie та подібні технології для основних функцій/налаштувань веб-сайту. Якщо ви бажаєте залишити це налаштування за замовчуванням, натисніть «НАЛАШТУВАННЯ ФАЙЛІВ COOKIE» та «ЗБЕРЕГТИ НАЛАШТУВАННЯ». Натиснувши «ПРИЙНЯТИ ВСІ ФАЙЛИ COOKIE», ви дозволяєте використовувати файли cookie для ВСІХ цілей, описаних у ',
        dismiss: 'Прийняти всі',
        deny: 'Відмовтеся від файлів cookie',
        link: 'НАЛАШТУВАННЯХ ФАЙЛОВ COOKIE',
        href: 'terms-and-conditions#cookies',
        policy: 'Політика використання файлів cookie'
    }
};

export function emailLinkInitializer(afAuth: AngularFireAuth) {
    return async () => {
        const href = window.location.href;

        // Quick debug if needed:
        // console.log('HREF:', href);

        // Must still include these:
        if (!href.includes('mode=signIn') || !href.includes('oobCode=')) return;

        // compat: sync boolean
        const ok = afAuth.isSignInWithEmailLink(href);
        if (!ok) return; // malformed or already stripped

        let email = localStorage.getItem('emailForSignIn') || '';
        if (!email) return; // show UI later to ask for email if cross-device

        try {
            await afAuth.signInWithEmailLink(email, href);
            localStorage.removeItem('emailForSignIn');
            // Optionally clean the URL (remove query) after success:
            history.replaceState({}, '', '/');
        } catch (e) {
            // swallow here; your app can show a nicer error later
            // console.error('Email link sign-in failed:', e);
        }
    };
}
@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        EyeTrackingTestComponent,
        QuestionnaireComponent,
        ResultsComponent,
        NavComponent,
        AuthComponent,
        FooterComponent,
        SigninComponent,
        SignupComponent,
        CalibrationComponent,
        TermsAndConditionsComponent,
        UserSessionsComponent,
        ConfirmSignInComponent,
        FilterByPipe,
        FeaturedBlogPostsComponent,
        HomeHeroComponent,
        WhatIsAnimaModalComponent,
        AboutUsComponent,
        AboutUsItemComponent,
        AchivementComponent,
        PublicationsComponent,
        PublicationItemComponent,
        ForWhoomComponent,
        ForWhoomItemComponent,
        ReviewsItemComponent,
        ReviewsPagerComponent,
        PlansComponent,
        PaymentComponent,
        AfterPaymentComponent,
        PlansItemComponent,
        FaqComponent,
        FaqItemComponent,
        ChooseTestComponent,
        ChooseTestItemComponent,
        ResultsContentComponent,
        ResultsWarningComponent,
        ResultsTrackerCalibrationComponent,
        ResultsTrackerComponent,

        TrackerCalendarComponent,
        RecommendationsComponent,
        RecommendationsItemComponent,
        SelectTestComponent,
        ResultsReminderComponent,
        IndexDynamicComponent,
        TestResultsComponent,
        TestPieChartComponent,
        TestLineChartComponent,
        ResultShareLinksComponent,
        DetailsComponent,
        IArrowComponent,

        GetHelpComponent,
        ErrorModalComponent,
        AboutPageComponent,
        CalendarModalComponent,
        UnsubscribeComponent,
        PaymentSuccessComponent,
        TestComponent,
        VideoStreamComponent,
        ReviewsComponent,
        ReportComponent,
        ProgressComponent,
        DashboardComponent,
        DashboardCalendarComponent,
        PatientDashboardComponent,
        NewSessionModalComponent,
        NewClientSessionComponent,
        ForBusinessComponent,
        HomeHeroForBusinessComponent,
        AboutUsBusinessComponent,
        AboutUsBItemComponent,
        AboutUsAiComponent,
        AboutUsAiItemComponent,

        // results
        AiLandingComponent,
        LineProgressComponent,
        ResultsIndexesComponent,
        CountUpDirective,
        TrackerArousalPerformanceComponent,
        TrackerVulnerabilityStressComponent,
        HomeHeroAiLandingComponent,
        PricingComponent,
        UserAnswersComponent,
        PromoComponent,

        // AI
        SidebarComponent,
        ChatResultsComponent,
        NewChatComponent

    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        NgbAccordionModule,
        NgbDropdownModule,
        NgbModalModule,
        NgbDatepickerModule,
        NgbNavModule,
        NgbTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFireStorageModule,
        AngularFireDatabaseModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        FormlyModule.forRoot({
            types: [
                {
                    name: 'text',
                    extends: 'input',
                    defaultOptions: {
                        templateOptions: {
                            type: 'text',
                        },
                    },
                }
            ],
            validationMessages: [
                {name: 'required', message: 'This field is required'},
            ],
        }),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        FormlyBootstrapModule,
        NgxMaskModule.forRoot(),
        SharedModule.forRoot({env: environment}),
        EyeTrackerModule.forRoot({apiUrl: environment.apiUrl}),
        ToastrModule.forRoot(),
        SlickCarouselModule,
        NgxPayPalModule,
        NgcCookieConsentModule.forRoot(cookieConfig),
        NgbProgressbarModule
    ],
    providers: [
        AuthService,
        DataService,
        NgbActiveModal,
        {
            provide: APP_INITIALIZER,
            useFactory: (af: AngularFireAuth) => emailLinkInitializer(af),
            deps: [AngularFireAuth],
            multi: true,
        },
        {provide: 'googleTagManagerId', useValue: environment.googleTagId},
        GoogleTagManagerService,
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {
            },
            deps: [TraceService],
            multi: true,
        },
    ],
    exports: [
        FeaturedBlogPostsComponent,
        TrackerCalendarComponent,
        FooterComponent,
        AboutUsBusinessComponent,
        ForWhoomComponent,

    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
